var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5581 7.10035L12.9009 5.44305C12.6722 5.21437 12.301 5.21422 12.0722 5.44305L10.0006 7.51465L7.92904 5.44305C7.70041 5.21437 7.3292 5.21422 7.10041 5.44305L5.44314 7.10035C5.21432 7.32914 5.21432 7.70016 5.44314 7.92899L7.51471 10.0006L5.44311 12.0722C5.21428 12.301 5.21428 12.672 5.44311 12.9008L7.10037 14.5581C7.329 14.7868 7.70021 14.787 7.929 14.5581L10.0006 12.4865L12.0722 14.5581C12.3009 14.7868 12.6721 14.787 12.9009 14.5581L14.5581 12.9008C14.787 12.672 14.787 12.301 14.5581 12.0722L12.4866 10.0006L14.5582 7.92899C14.787 7.70016 14.787 7.32914 14.5581 7.10035V7.10035ZM11.2436 9.58629C11.0148 9.81508 11.0148 10.1861 11.2436 10.4149L13.3152 12.4865L12.4866 13.3152L10.415 11.2436C10.1862 11.0148 9.81518 11.0148 9.58635 11.2436L7.51475 13.3152L6.68611 12.4865L8.75771 10.4149C8.98654 10.1861 8.98654 9.81512 8.75771 9.58629L6.68611 7.51469L7.51475 6.68602L9.58635 8.75762C9.81514 8.98641 10.1862 8.98641 10.415 8.75762L12.4866 6.68602L13.3152 7.51469L11.2436 9.58629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.49379 0 0 4.4941 0 10C0 15.5062 4.4941 20 10 20C15.5062 20 20 15.5059 20 10C20 4.49379 15.5059 0 10 0ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3cc785cd07b7732cd4201e413135c523.svg";
export { ForwardRef as ReactComponent };